export default "__VITE_ASSET__CGlpmEs$__"